/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, FormHelperText } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import SearchNotFound from '../../../SearchNotFound';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';


var screenCode = "STOCKBALANCEREPORT"

function CollapsibleRow({ row }) {
    const [open, setOpen] = React.useState(false);

    return (
        <React.Fragment>
            <TableRow>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>{row.productCategoryName}</TableCell>
                <TableCell>{row.productName}</TableCell>
                <TableCell>{row.measuringUnit == 1 ? 'Unit' : row.measuringUnit == 2 ? 'Kg' : 'g'}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="subtitle1" gutterBottom component="div">
                                GTN Details
                            </Typography>
                            <Table size="small" aria-label="grn-details">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">GTN Number</TableCell>
                                        <TableCell align="left">GTN Date</TableCell>
                                        <TableCell align="right">Qty</TableCell>
                                        <TableCell align="right">Issue Qty</TableCell>
                                        <TableCell align="right">Damaged Qty</TableCell>
                                        <TableCell align="right">Available Qty</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(row.grnDetails || []).map((grn, idx) => (
                                        <TableRow key={grn.grnNumber || idx}>
                                            <TableCell align="left">{grn.grnNumber}</TableCell>
                                            <TableCell align="left">  {grn.grnDate ? new Date(grn.grnDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' }) : ''}</TableCell>
                                            <TableCell align="right">{Number(grn.qty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="right">{Number(grn.issuedQty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="right">{Number(grn.refusedQuantity).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="right">{Number(grn.availableQty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                        </TableRow>
                                    ))}
                                    {(!row.grnDetails || row.grnDetails.length === 0) && (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center">No GRN Details</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function StockBalanceReport(props) {

    const navigate = useNavigate();
    const componentRef = useRef();

    const [csvHeaders, SetCsvHeaders] = useState([]);
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('productForecastdate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcategory, setProductcategory] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [stockBalanceDetails, setStockBalanceDetails] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        factoryID: 0,
        productCategoryID: 0,
        productID: 0,
        fromDate: fromDate,
        toDate: toDate,
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const validationSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        factoryID: Yup.number().min(1, 'Please Select Factory').required('Factory Required'),
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        factoryID: '',
        productCategoryID: '',
        productID: '',
        fromDate: '',
        toDate: '',
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            factoryID: formData.factoryID,
            productCategoryID: formData.productCategoryID,
            productID: formData.productID,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSTOCKBALANCEREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategories());
    }

    async function SubmitForm() {
        let formattedFromDate = new Date(fromDate).toISOString();
        let formattedToDate = new Date(toDate).toISOString();
        let model = {
            groupID: formik.values.groupID,
            factoryID: formik.values.factoryID,
            productCategoryID: formik.values.productCategoryID,
            productID: formik.values.productID,
            fromDate: formattedFromDate,
            toDate: formattedToDate,
        }
        var response = await services.GetStockBalanceReportData(model);
        setStockBalanceDetails(response);
        createDataForExcel(res);
        getSelectedDropdownValuesForReport(model);
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        setValues({
            ...values,
            productCategoryID: 0,
            productID: 0,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
        });
        setStockBalanceDetails([]);
        setFromDate(new Date());
        setToDate(new Date());
    }

    useEffect(() => {
        if (formik.values.productCategoryID != 0) {
            trackPromise(GetProductDetails());
        }
    }, [formik.values.productCategoryID, formik.values.factoryID]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
        setValues({
            ...formik.values,
            groupID: formik.values.groupID,
            factoryID: formik.values.factoryID,
            productCategoryID: 0,
            productID: 0,
            fromDate: setFromDate(new Date()),
            toDate: setToDate(new Date()),
        });
        setStockBalanceDetails([]);
    }, [formik.values.groupID]);

    useEffect(() => {
        setValues({
            ...formik.values,
            factoryID: formik.values.factoryID,
            productCategoryID: 0,
            productID: 0,
            fromDate: setFromDate(new Date()),
            toDate: setToDate(new Date()),
        });
        setStockBalanceDetails([]);
    }, [formik.values.factoryID]);

    useEffect(() => {
        setValues({
            ...formik.values,
            productCategoryID: formik.values.productCategoryID,
            productID: 0,
            fromDate: setFromDate(new Date()),
            toDate: setToDate(new Date()),
        });
        setStockBalanceDetails([]);
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setValues({
            ...formik.values,
            productID: formik.values.productID,
            fromDate: setFromDate(new Date()),
            toDate: setToDate(new Date()),
        });
        setStockBalanceDetails([]);
    }, [formik.values.productID]);

    useEffect(() => {
        setStockBalanceDetails([]);
    }, [fromDate, toDate]);

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        const factoryType = parseInt(TokenDecoder.getFactoryTypeFromToken());
        var res = await services.GetAllFactoriesByFactoryType(formik.values.groupID, factoryType)
        if (res != null) {
            setFactory(res);
        }
    }

    async function GetProductCategories() {
        var res = await services.GetProductCategories();
        if (res != null) {
            setProductcategory(res);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(formik.values.factoryID, formik.values.productCategoryID);
        if (res != null) {
            setProduct(res);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(stockBalanceDetails);
        var settings = {
            sheetName: 'Audit Report',
            fileName: 'Stock Balance Report_' + new Date(fromDate).toISOString().split('T')[0],
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Audit Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array, filterDetails) {
        var res = [];
        if (array != null) {
            array.forEach(product => {
                if (product.grnDetails && product.grnDetails.length > 0) {
                    product.grnDetails.forEach(grn => {
                        var vr = {
                            'Product Category': product.productCategoryName,
                            'Product': product.productName,
                            'Measuring Unit': product.measuringUnit == 1 ? 'Unit' : product.measuringUnit == 2 ? 'Kg' : 'g',
                            'GTN Number': grn.grnNumber,
                            'GTN Date': grn.grnDate ? new Date(grn.grnDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' }) : '',
                            'Qty': Number(grn.qty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                            'Issued Qty': Number(grn.issuedQty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                            'Damaged Qty': Number(grn.refusedQuantity).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                            'Available Qty': Number(grn.availableQty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        };
                        res.push(vr);
                    });
                } else {
                    var vr = {
                        'Product Category': product.productCategoryName,
                        'Product': product.productName,
                        'Measuring Unit': product.measuringUnit == 1 ? 'Unit' : product.measuringUnit == 2 ? 'Kg' : 'g',
                        'GTN Number': '',
                        'GTN Date': '',
                        'Qty': '',
                        'Issued Qty': '',
                        'Damaged Qty': '',
                        'Available Qty': '',
                    };
                    res.push(vr);
                }
            });
        }
        return res;
    }

    function getSelectedDropdownValuesForReport(data) {
        let groups = group.find(x => x.groupID == formik.values.groupID)
        let factories = factory.find(x => x.factoryID == formik.values.factoryID);
        let productcategories = productcategory.find(x => x.value == formik.values.productCategoryID);
        let products = product.find(x => x.value == formik.values.productID);

        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups.groupName,
            factory: factories.factoryName,
            productCategory: productcategories.productCategoryName,
            product: products.productName,
        });
    }

    function generateProductCategoryDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(x.isActive == true ? <MenuItem key={x.productCategoryID} value={x.productCategoryID}>{x.productCategoryName}</MenuItem> : null)
            });
        }
        return items
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Stock Balance Report |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/stockBalanceReport"}
                        btname="Add"
                        pageName="Stock Balance Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Operation Entity *"
                                        id="factoryID"
                                        value={formik.values.factoryID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('factoryID')}
                                        error={Boolean(touched.factoryID && errors.factoryID)}
                                        helperText={touched.factoryID && errors.factoryID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Operation Entity</MenuItem>
                                        {factory.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Product Category"
                                        value={formik.values.productCategoryID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('productCategoryID')}
                                        error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                        helperText={touched.productCategoryID && errors.productCategoryID}
                                    >
                                        <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                                        {generateProductCategoryDropDownMenu(productcategory)}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Product"
                                        value={formik.values.productID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('productID')}
                                        error={Boolean(touched.productID && errors.productID)}
                                        helperText={touched.productID && errors.productID}
                                    >
                                        <MenuItem key={0} value={0}> Select Product</MenuItem>
                                        {product.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.productID} value={option.productID}>
                                                {option.productName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="From Date"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="ToDate"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <div>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </div>
                            </Stack>
                            {/* </Stack> */}
                            <br />
                            <>
                                {stockBalanceDetails.length > 0 ? (
                                    <Card style={{ justifycontent: 'center', width: '100%' }}>
                                        <Paper className={classes.paper}>
                                            <TableContainer>
                                                <Table className={classes.table} aria-label="collapsible table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell />
                                                            <TableCell>Product Category</TableCell>
                                                            <TableCell>Product</TableCell>
                                                            <TableCell>Measuring Unit</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {stockBalanceDetails
                                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            .map((row, idx) => (
                                                                <CollapsibleRow key={row.productID + '-' + row.productCategoryID + '-' + idx} row={row} />
                                                            ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25]}
                                                component="div"
                                                count={stockBalanceDetails.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </Paper>
                                    </Card>
                                ) : <SearchNotFound searchQuery="Stock Balance Report" />}
                            </>
                        </Form>
                    </FormikProvider>
                    {stockBalanceDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Stock Balance Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    stockBalanceDetails={stockBalanceDetails}
                                    searchData={selectedSearchValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}